import { useMemo } from 'react';
import { makeRootClassName, makeBEM } from '../../../../utils';
export var useFilterViewerClassNames = function useFilterViewerClassNames(classPrefix, className) {
  return useMemo(function () {
    return {
      Root: makeRootClassName(classPrefix, className),
      AddFiltersButton: makeBEM(classPrefix, 'AddFiltersButton'),
      TopBar: makeBEM(classPrefix, 'TopBar'),
      TopBarSummary: makeBEM(classPrefix, 'Summary'),
      TopBarTitle: makeBEM(classPrefix, 'TopBarTitle'),
      TopBarResultCount: makeBEM(classPrefix, 'TopBarResultCount'),
      Actions: makeBEM(classPrefix, 'Actions'),
      EditFiltersButton: makeBEM(classPrefix, 'EditFiltersButton'),
      ClearFiltersButton: makeBEM(classPrefix, 'ClearFiltersButton'),
      ClearFiltersConfirmation: makeBEM(classPrefix, 'ClearFiltersConfirmation'),
      ClearFiltersConfirmationTitle: makeBEM(classPrefix, 'ClearFiltersConfirmationTitle'),
      ClearFiltersConfirmationDescription: makeBEM(classPrefix, 'ClearFiltersConfirmationDescription'),
      ClearFiltersConfirmationCancelButton: makeBEM(classPrefix, 'ClearFiltersConfirmationCancelButton'),
      ClearFiltersConfirmationConfirmButton: makeBEM(classPrefix, 'ClearFiltersConfirmationConfirmButton'),
      Conditions: makeBEM(classPrefix, 'Conditions'),
      AddFilterHint: makeBEM(classPrefix, 'AddFilterHint')
    };
  }, [classPrefix, className]);
};